import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { TimeEntry } from "@/types/time-entry";
import { EditEntryForm } from "./EditEntryForm";
import { useTimeEntryForm } from "@/hooks/useTimeEntryForm";

interface EditEntryDialogProps {
  entry: TimeEntry;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function EditEntryDialog({ entry, open, onOpenChange }: EditEntryDialogProps) {
  const form = useTimeEntryForm(entry, () => onOpenChange(false));

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Zeiteintrag bearbeiten</DialogTitle>
        </DialogHeader>
        <EditEntryForm form={form} />
      </DialogContent>
    </Dialog>
  );
}
